<template>
    <div>
        <select-input
            v-model="company_id"
            name="company_id"
            :options="companyOptions"
            :required="true"
            placeholder="Välj..."
        >
            Entreprenör
        </select-input>
        <assign-field-technician
            v-for="(user, index) in users"
            :key="user.id"
            :is-last="isLastIndex(index)"
            :user="user"
            :existing-field-technician-ids="existingFieldTechnicianIds"
        />
        <div v-if="users.length === 0" class="py-lg italic">
            Den valda entreprenören har inga fälttekniker.
        </div>
    </div>
</template>

<script>
    import AssignFieldTechnician from './AssignFieldTechnician';

    export default {
        components: {
            AssignFieldTechnician,
        },
        props: {
            companies: {
                type: Array,
                required: true,
            },
            companyOptions: {
                type: Object,
                required: true,
            },
            existingFieldTechnicianIds: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                company_id: null,
            };
        },
        computed: {
            users() {
                if (! this.company_id) {
                    return [];
                }

                return Object.keys(this.companies)
                    .map((company) => this.companies[company])
                    .find((company) => company.id === parseInt(this.company_id)).users;
            },
        },
        created() {
            this.company_id = this.companies[parseInt(Object.keys(this.companies))].id;
        },
        methods: {
            isLastIndex(index) {
                return parseInt(index) === parseInt(Object.keys(this.users).length);
            },
        },
    };
</script>
